import React__default, { useState, useEffect } from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Foldable } from '../Foldable/index.js';

var _excluded = ["children"];
var AutoExpand = function AutoExpand(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  useEffect(function () {
    return setOpen(true);
  }, []);
  return /*#__PURE__*/React__default.createElement(Foldable, _extends({}, props, {
    open: open
  }), children);
};

export { AutoExpand };
//# sourceMappingURL=index.js.map
